import React, { useState, useEffect } from "react";
import { Box, Link, Button, useBreakpointValue } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";

const KsStickyButton = ({ sectionContent }) => {
  const { buttonText, linkUrl } = sectionContent[0] || {};
  const [isVisible, setIsVisible] = useState(false);

  // Determine the current device breakpoint
  const isBaseDevice = useBreakpointValue({ base: true, md: false });
  const isMdDevice = useBreakpointValue({ base: false, md: true, xl: false });

  useEffect(() => {
    const handleScroll = () => {
      const secondComponent = document.getElementById("ks-spiritual-growth");
      const fifthComponent = document.getElementById("ks-program-details");

      if (secondComponent && fifthComponent) {
        const secondComponentRect = secondComponent.getBoundingClientRect();
        const fifthComponentBottom = fifthComponent.getBoundingClientRect().bottom;

        if (isBaseDevice) {
          // Logic for base (small screens)
          const secondComponentHeight = secondComponentRect.height;
          const isThirtyPercentScrolledOut =
            secondComponentRect.top + secondComponentHeight * 0.02 <= 0;

          setIsVisible(isThirtyPercentScrolledOut && fifthComponentBottom > -250);
        } else if (isMdDevice) {
          // Logic for medium screens
          const buffer = 280; // Smaller buffer for medium screens
          const scrollPosition = window.innerHeight * 0.01; // Adjust scroll position for medium screens
          setIsVisible(
            secondComponentRect.top <= scrollPosition &&
            fifthComponentBottom > -buffer
          );
        } else {
          // Logic for large screens
          const buffer = 780; // Larger buffer for large screens
          const scrollPosition = window.innerHeight * 0.01; // Center-based logic for large screens
          setIsVisible(
            secondComponentRect.top <= scrollPosition &&
            fifthComponentBottom > -buffer
          );
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isBaseDevice, isMdDevice]);

  if (!isVisible) return null;

  // Base (small screens) design
  if (isBaseDevice) {
    return (
      <Box
        position="fixed"
        bottom="0"
        width="100%"
        backgroundColor="#0E2975"
        p="4"
        boxShadow="sm"
        zIndex="99"
        textAlign="center"
        h="79px"
      >
        <Link
          href={linkUrl}
          textDecoration="none"
          _hover={{ textDecoration: "none" }}
          mx="auto"
        >
          <Button
            width="166px"
            maxWidth="320px"
            height="50px"
            borderRadius="10px"
            backgroundColor="#ECBD47"
            color="#031564"
            fontSize="18px"
            fontWeight="bold"
            lineHeight="28.8px"
            textAlign="center"
            fontFamily="FedraSansStd-book"
            boxShadow="0px 4px 6px rgba(0, 0, 0, 0.2)"
            border="none"
            _hover={{
              backgroundColor: "#E0B544",
              color: "#031564",
            }}
            mx="auto"
          >
            {buttonText}
            <ChevronRightIcon boxSize="24px" mt="2px" />
          </Button>
        </Link>
      </Box>
    );
  }

  // Medium and large screens design
  return (
    <Box
      position="fixed"
      top="50%"
      transform="translateY(-50%)"
      sx={{
        right: {
          md: "0",
        },
        "@media (min-width: 1320px)": {
          marginRight: "calc(50% - 651px)",
        },
      }}
      zIndex="99"
    >
      <Link
        href={linkUrl}
        textDecoration="none"
        _hover={{ textDecoration: "none" }}
      >
        <Button
          width="152px"
          height="91px"
          borderRadius="5px 0 0 5px"
          backgroundColor="#ECBD47"
          color="#031564"
          fontSize="20px"
          fontWeight="bold"
          lineHeight="1.2"
          textAlign="center"
          whiteSpace="normal"
          fontFamily="FedraSansStd-book"
          boxShadow="0px 4px 6px rgba(0, 0, 0, 0.2)"
          border="none"
          _hover={{
            backgroundColor: "#E0B544",
            color: "#031564",
          }}
        >
          {buttonText}
        </Button>
      </Link>
    </Box>
  );
};

export default KsStickyButton;